export const ACCOUNT_TYPES = (): any[] => {
  return [
    { value: 'checking', label: 'Conta Corrente', color: '#7F7F7F' },
    { value: 'savings', label: 'Conta Poupança', color: '#EBB764' },
    { value: 'investment', label: 'Investimento', color: '#E97737' },
    { value: 'sub_account', label: 'Dinheiro em Mãos', color: '#9060D2' },
    // { value: 'loans', label: 'Empréstimos', color: '#5FA1ED' },
    // { value: 'insurance', label: 'seguros', color: '#68f592' },
  ]
}